export const environment = {
    version: require('../../package.json').version,
    authTimeout: 30000, // ms
    debug: {
        logLevel: '',
        logCDTime: false,
        enableClassProfiler: false,
        enableFnProfiler: false
    },
    appInsights: {
        config: {
            instrumentationKey: '#{APPINSIGHT_PUBLIC_FACING_KEY}#',
            autoTrackPageVisitTime: true,
            enableCorsCorrelation: true,
            enableRequestHeaderTracking: true,
            enableResponseHeaderTracking: true,
            correlationHeaderExcludedDomains: [
                '*datadoghq.com'
            ]
        }
    }
}
